import AppComponent from '../../mixins/app-component'

import AppHomeSlideNbTitle from '../app-home-slide-nb-title'
import AppIcon from '../app-icon'

import * as Random from '../../utils/Random'

export default
{
    name: 'app-home-slide-1',

    mixins: [
        AppComponent
    ],

    components: {
        AppHomeSlideNbTitle,
        AppIcon
    },

    props: {
        activeIndex: { type: Number, default: 0 },
        activeLevel: { type: Number, default: 0 }
    },

    data() {
        return {
            pracEarned: 0,
            pracEarnedString: '0.00',
            hoverInformationsHidden: false
        }
    },

    watch: {
        pracEarned: 'onPracEarnedChange',
        activeLevel: 'onActiveLevelChange'
    },

    created() {
        this.soundsIdLaunched = null
        this.soundsIdLaunchedLast = null

        this.eventHub.$on('app-home-slide-1:update-prac-earned', this.onUpdatePracEarned)
    },

    mounted() {
        this.button = this.$el.querySelector('.js-home-slide-1-button')
        this.buttonTimeout = null
    },

    destroyed() {
        this.eventHub.$off('app-home-slide-1:update-prac-earned', this.onUpdatePracEarned)
    },

    methods: {
        onActiveLevelChange() {
            if (this.activeLevel === 2) {
                setTimeout(() => {
                    this.hoverInformationsHidden = this.activeLevel === 2
                }, 3000)
            } else {
                this.hoverInformationsHidden = false
            }
        },

        onUpdatePracEarned(value) {
            this.pracEarned = value

            if (this.pracEarned > 0) {
                this.soundsIdLaunchedLast = this.soundsIdLaunched

                this.soundsIdLaunched = Random.randomIntBetween(1, 10)
                while (this.soundsIdLaunched === this.soundsIdLaunchedLast) {
                    this.soundsIdLaunched = Random.randomIntBetween(1, 10)
                }


                this.eventHub.$emit('app-sound-manager:back-to-start', `tinkle_${this.soundsIdLaunched}`)
                this.eventHub.$emit('app-sound-manager:play', `tinkle_${this.soundsIdLaunched}`)
            }

            if (this.pracEarned === 12) {
                setTimeout(() => {
                    this.eventHub.$emit('page-home:onNextSlide')
                }, 1000)
            }

            // this.hoverInformationsHidden = this.pracEarned >= 4
        },

        onPracEarnedChange() {
            this.pracEarnedString = `${this.pracEarned}.00`
        },

        _onClickOnButton() {
            this.eventHub.$emit('page-home:onNextSlide', this.onNextSlide)
        },

        _onMouseenterButton() {
            if (this.button) {
                this.button.classList.add('is-hover-1')

                this.buttonTimeout = setTimeout(() => {
                    this.button.classList.remove('is-hover-1')
                    this.button.classList.add('is-hover-2')
                }, 425)
            }
        },

        _onMouseleaveButton() {
            if (this.button) {
                clearTimeout(this.buttonTimeout)

                this.button.classList.remove('is-hover-1')
                this.button.classList.remove('is-hover-2')
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-home-slide-1/script.js